import { GdkCheckpoint } from "@gdk/checkpoint";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import GeaoLayout from "../shared/Layout/GeaoLayout";
import { GeaoPaths } from "../../constants/GeaoPaths";
import useTitle from "../../../../hooks/useTitle";
import useGtmTracking from "../../../../hooks/useGtmTracking";

export default function CreateYourProfileChecklist() {
    useTitle("Welcome to GEICO For Your Agency");

    useGtmTracking("OnboardingOverview", "preonboarding_start");

    const navigate = useNavigate();
    const location = useLocation();
    const [showAlert] = useState(location.state?.alert === "maximumTries");

    useEffect(() => {
        new GdkCheckpoint({
            content: `#overview-checkpoint`,
            data: [
                {
                    title: "Create Your Profile",
                    status: "in process"
                },
                {
                    title: "Complete Application"
                },
                {
                    title: "Background Check"
                },
                {
                    title: "Start selling with GEICO"
                }
            ],
            animated: false
        });
    }, []);

    return <>
        <GeaoLayout>
            {showAlert &&
                <div className="alert">
                    <div className="alert--high-importance">
                        <span className="icon-alert" />
                        <ul className="alert-list">
                            <li className="alert-content">
                                <div className="h4">Maximum Attempts Exceeded</div>
                                <p>
                                    You have exceeded the maximum number of attempts. Please try again later.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            }
            <h2 className="mx-auto mt-5 mb-1">Welcome to GEICO For Your Agency.</h2>
            <div className="mx-auto mb-5">Thanks for considering becoming an agent with GEICO!</div>
            <div className="container margin-top">
                <div className="row">
                    <div className="col-md-6">
                        <div className="checkpoint p-3 background m-2 overview-block" id="overview-checkpoint">
                            <p className="checkpoint checkpoint-heading">What's Next?</p>
                            <ul className="checkpoint-content"></ul>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="m-2">
                            <p className="header-text">Have these details ready:</p>
                            <ul className="list list--unordered">
                                <li>
                                    Individual National Producer Number (NPN)
                                </li>
                                <li>
                                    Employer Identification Number (EIN)
                                </li>
                            </ul>
                            <p className="header-text">GEICO For Your Agency qualifications:</p>
                            <ul className="list list--unordered">
                                <li>
                                    Operate as an independent agent
                                </li>
                                <li>
                                    Have an Errors and Omissions (E&O) Policy or intend to obtain one
                                </li>
                            </ul>
                            <p> This task will take approximately 5 minutes. </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mx-auto mt-5" style={{ justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                <button
                    type="submit"
                    className="btn-center btn--primary btn--full-mobile"
                    onClick={() => navigate(GeaoPaths.CreateYourProfile)}
                    style={{ width: '350px', marginBottom: 5 }}
                >
                    <span>
                        Create Your Profile
                    </span>
                </button>

                <button
                    type="submit"
                    className="btn-center btn--secondary btn--full-mobile"
                    style={{ width: '350px' }}
                    onClick={() => navigate(GeaoPaths.ApplicationStatus)}
                >
                    <span>
                        View Application Status
                    </span>
                </button>
            </div>
        </GeaoLayout>
    </>
}
